// LoadingDots.js
import React from 'react';

const LoadingDots = () => {
    return (
        <div className="flex justify-center items-center space-x-2">
            <div className="w-2.5 h-2.5 bg-gray-800 rounded-full animate-bounce"></div>
            <div className="w-2.5 h-2.5 bg-gray-800 rounded-full animate-bounce animation-delay-200"></div>
            <div className="w-2.5 h-2.5 bg-gray-800 rounded-full animate-bounce animation-delay-400"></div>
        </div>
    );
};

export default LoadingDots;
